import React from 'react'
import { Container, ContentData, SideBarStyles } from './styles'
import useIsMobile from '../../../../hooks/useIsMobile'
import Avatar from '../../../../components/Avatar'
import { ContentCenter } from '../../../../components/commons'
import { format, isValid } from 'date-fns'
import { api } from '../../../../services/api'
import { User } from '../../../../services/users.service'
import { LoaderComponent } from '../../../../components/Button/styles'
import { Empty } from '../../../../components/Table/styles'
import Pagination from '../../../../components/Table/Pagination'
import DateRangeInput from '../../../../components/Input/DateRangeInput'
import { useForm } from 'react-hook-form'
import ClickAwayListener from 'react-click-away-listener'
import { FaFilter, FaXmark } from 'react-icons/fa6'
import { ButtonRound } from '../../../../components/Header/styles'

export interface SideBarLogsHandle {
  openModal: (_id: string) => void
  closeModal: () => void
}

export interface SideBarLogsProps {}

interface Logs {
  label: string
  createdAt: string
}

const SideBarLogs: React.ForwardRefRenderFunction<SideBarLogsHandle, SideBarLogsProps> = (
  {},
  ref,
) => {
  const isMobile = useIsMobile()

  const [isLoading, setIsLoading] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [user, setuser] = React.useState<User>()
  const [openTimeout, setOpenTimeout] = React.useState(false)
  const [logs, setLogs] = React.useState<Logs[]>([])
  const [page, setPage] = React.useState(1)
  const [totalPages, setTotalPages] = React.useState(1)

  const {
    control,
    watch,
    formState: { errors },
  } = useForm<any>()

  const date = watch('range')

  const pageChangeHandler = (page: number) => setPage(page)

  const handleGetList = async (_id?: string, page?: number) => {
    try {
      if (page === 1) setIsLoading(true)
      const { data: response } = await api.get(`/logs/${_id}`, {
        params: {
          page: page || 1,
          perPage: 10,
          startDate: date?.startDate,
          endDate: date?.endDate,
        },
      })
      setLogs(response.data)
      setPage(response.page)
      setTotalPages(response.totalPages)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleGetData = async (_id?: string) => {
    try {
      setIsLoading(true)

      const { data: response } = await api.get(`/users/${_id}`)
      setuser(response)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleClickAway = () => {
    setOpen(false)
    setOpenTimeout(false)
  }

  React.useImperativeHandle(ref, () => ({
    openModal(_id) {
      setOpen(true)
      handleGetData(_id)
      handleGetList(_id)
      setTimeout(() => {
        setOpenTimeout(true)
      }, 2000)
    },
    closeModal() {
      handleClickAway()
    },
  }))

  React.useEffect(() => {
    if (user?._id) {
      handleGetList(user?._id, page)
    }
  }, [page, date])

  return (
    <ClickAwayListener onClickAway={() => (openTimeout ? handleClickAway() : {})}>
      <Container open={open}>
        <SideBarStyles.Header>
          <SideBarStyles.Title>Histórico do Usuário</SideBarStyles.Title>
          <SideBarStyles.ButtonsClose>
            <DateRangeInput control={control} name='range'>
              <ButtonRound>
                <FaFilter color='white' size={15} />
              </ButtonRound>
            </DateRangeInput>
            <ButtonRound onClick={() => handleClickAway()}>
              <FaXmark color='white' size={15} />
            </ButtonRound>
          </SideBarStyles.ButtonsClose>
        </SideBarStyles.Header>
        <ContentCenter style={{ gap: 10 }}>
          <Avatar source={user?.photo} width={150} height={150} />
          <SideBarStyles.Name>{user?.name}</SideBarStyles.Name>
          <SideBarStyles.Desc>{user?.email}</SideBarStyles.Desc>
        </ContentCenter>
        <ContentData>
          {isLoading && <LoaderComponent />}
          {!isLoading && !logs?.length && <Empty>Nenhum log encontrado</Empty>}
          <ContentCenter>
            {logs.map((item) => (
              <SideBarStyles.RowItem>
                <SideBarStyles.RowName>{item.label}</SideBarStyles.RowName>
                <SideBarStyles.RowName
                  style={{
                    width: '40%',
                  }}
                >
                  {(() => {
                    try {
                      const date = new Date(item.createdAt);
                      if (isValid(date)) {
                        return format(date, 'dd/MM/yyyy HH:mm');
                      }
                      return '-';
                    } catch (error) {
                      console.warn('Erro ao formatar data do log:', error);
                      return '-';
                    }
                  })()}
                </SideBarStyles.RowName>
              </SideBarStyles.RowItem>
            ))}
          </ContentCenter>
        </ContentData>
        {totalPages && (
          <Pagination
            totalPages={totalPages}
            page={page}
            perPage={18}
            pageChangeHandler={pageChangeHandler}
          />
        )}
      </Container>
    </ClickAwayListener>
  )
}

export default React.forwardRef(SideBarLogs)
